"use client";

import { onSnapshot, type DocumentReference } from "firebase/firestore";

export type CheckoutSession = { id: string; url: string };

/** The extension writes either a checkout URL or an error back to this document. */
export function waitForCheckoutSession(document: DocumentReference): Promise<CheckoutSession> {
  let unsubscribe: (() => void) | undefined;
  let timeout: ReturnType<typeof setTimeout>;
  return new Promise<CheckoutSession>((resolve, reject) => {
    timeout = setTimeout(() => {
      reject(new Error("Checkout did not respond. Please try again."));
    }, 30_000);
    unsubscribe = onSnapshot(document, (snapshot) => {
      const session = snapshot.data();
      if (!session) return;
      if (session.error) {
        const detail = typeof session.error.message === "string"
          ? session.error.message : "Stripe could not create a checkout session.";
        reject(new Error(`Checkout could not start: ${detail}`));
        return;
      }
      if (typeof session.sessionId === "string" && session.sessionId && typeof session.url === "string" && session.url) {
        resolve({ id: session.sessionId, url: session.url });
      }
    }, reject);
  }).finally(() => {
    clearTimeout(timeout);
    unsubscribe?.();
  });
}
